import { createAction } from 'redux-actions';

export const addPackageOption = createAction('ADD_INVENTORY_PACKAGE_OPTION');

export const updatePackageOption = createAction(
  'UPDATE_INVENTORY_PACKAGE_OPTION'
);

export const removePackageOption = createAction(
  'REMOVE_INVENTORY_PACKAGE_OPTION'
);
